import React from "react";
import RCPaginate from "rc-pagination";
import styled from "styled-components";
import { STYLES } from "../../constants";

function Pagination(props) {
  return <SPagination {...props} showTitle={false} />;
}

const SPagination = styled(RCPaginate)`
  & {
    @media (max-width: ${STYLES.screen.md}) {
      display: flex;
      > li {
        margin-right: 0;
      }
    }
  }
  .rc-pagination-next,
  .rc-pagination-prev {
    display: none;
    @media (max-width: ${STYLES.screen.md}) {
      display: block;
      font-size: 32px;
      border: none;
      outline: none;
    }
  }

  .rc-pagination-item {
    min-width: 34px;
    height: 34px;
    line-height: 34px;
    font-size: 20px;
    font-weight: bold;
    color: #6d6d6d;
    border: none;
    outline: none;
    @media (max-width: ${STYLES.screen.md}) {
      margin-right: 4px;
    }
  }
  .rc-pagination-item-active {
    border-radius: 1px;
    background-color: ${STYLES.color.blue};
    color: #ffffff;
  }

  .rc-pagination-item-active a {
    color: #ffffff;
  }

  .rc-pagination-jump-prev:after,
  .rc-pagination-jump-next:after {
    color: #6d6d6d;
  }

  .rc-pagination-jump-prev:hover:after,
  .rc-pagination-jump-next:hover:after {
    color: ${STYLES.color.blue};
    font-size: 16px;
  }
`;

export default Pagination;
